import * as Sentry from '@sentry/browser';
import React from 'react';
import { AlertUnableToDownloadReport } from '@/alert-string-constants';
import { strOracleApiSender } from '@/utils/stroracle-api-sender';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 200px;
  padding: 0 15px 15px 15px;

  > div {
    margin-bottom: 20px;
  }
`;

const nameOfLatestReport = 'Property Count Report';
const repRoute = 'listing_count_report';
const arrBuffType = 'arraybuffer';

export function ReportDownload() {
  const downloadClick = async () => {
    try {
      const { data } = await strOracleApiSender.rawGet(
        repRoute,
        undefined,
        arrBuffType
      );

      if (!data.signed_url) {
        throw new Error('No signed URL returned');
      }

      const link = document.createElement('a');
      link.href = data.signed_url;
      link.click();
      link.remove();
    } catch {
      Sentry.captureMessage(AlertUnableToDownloadReport);
      toaster.error(AlertUnableToDownloadReport);
    }
  };
  return (
    <Wrapper>
      <div>{nameOfLatestReport}</div>
      <button onClick={downloadClick}>Download</button>
    </Wrapper>
  );
}
